<button mat-button
        [matMenuTriggerFor]="profilemenu">
    <div class="user-profile-img">
        <span>{{userName}}</span>
        @if (userImg) {
            <img [src]="userImg"
                 class="user_img"
                 width="32"
                 height="32"
                 alt="User">
        } @else {
            <span class="user_img user_img--fallback">{{ userInitials }}</span>
        }
    </div>
</button>

<mat-menu #profilemenu="matMenu"
          class="profile-menu"
          (menuClosed)="isSettingsCollapsed = true; isCentersCollapsed = true">
    <div class="noti-list">
        <div class="menu">
            <div class="user_dw_menu">
                <button mat-menu-item
                        class="user-item-list"
                        *appCanAccess="accountAccess"
                        (click)="onAccountClick()">
                    <app-feather-icons [icon]="'user'"
                                       [class]="'user-menu-icons'"></app-feather-icons>
                    <span class="user-item-label">{{ 'userProfileMenu.profile' | translate }}</span>
                </button>

                <button mat-menu-item
                        class="user-item-list"
                        *appCanAccess="inboxAccess"
                        (click)="onInboxClick()">
                    <app-feather-icons [icon]="'mail'"
                                       [class]="'user-menu-icons'"></app-feather-icons>
                    <span class="user-item-label">{{ 'userProfileMenu.inbox' | translate }}</span>
                </button>

                @if (showCentersEntry) {
                    <button mat-menu-item
                            type="button"
                            class="user-item-list settings-toggle"
                            *appCanAccess="centersSettingsAccess"
                            (click)="toggleCenters($event)">
                        <span class="settings-toggle-content">
                            <app-feather-icons [icon]="'map-pin'"
                                               [class]="'user-menu-icons'"></app-feather-icons>
                            <span class="settings-toggle-label user-item-label">
                                {{ currentCenterName || currentCenter || ('userProfileMenu.centers' | translate) }}
                            </span>
                            <i class="material-icons-outlined settings-toggle-icon">
                                {{ isCentersCollapsed ? 'add' : 'remove' }}
                            </i>
                        </span>
                    </button>
                    <div class="collapse settings-collapse"
                         *appCanAccess="centersSettingsAccess"
                         [ngClass]="isCentersCollapsed ? '' : 'show'">
                        @for (center of availableCenters; track center) {
                            <button mat-menu-item
                                    class="user-item-list settings-item"
                                    (click)="onSelectCenter(center)">
                                <app-feather-icons [icon]="'map'"
                                                   [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                                <span class="user-item-label">
                                    {{ center.name }}
                                    @if (center.center === currentCenter) {
                                        <strong>•</strong>
                                    }
                                </span>
                            </button>
                        }
                    </div>
                }
                <button mat-menu-item
                        type="button"
                        class="user-item-list settings-toggle"
                        *appCanAccess="settingsAccess"
                        (click)="toggleSettings($event)">
                    <span class="settings-toggle-content">
                        <!-- <span class="settings-toggle-left"> -->
                            <app-feather-icons [icon]="'settings'"
                                               [class]="'user-menu-icons'"></app-feather-icons>
                            <span class="settings-toggle-label user-item-label">{{ 'userProfileMenu.settings' | translate }}</span>
                        <!-- </span> -->
                        <i class="material-icons-outlined settings-toggle-icon">
                            {{ isSettingsCollapsed ? 'add' : 'remove' }}
                        </i>
                    </span>
                </button>
                <div class="collapse settings-collapse"
                     *appCanAccess="settingsAccess"
                     [ngClass]="isSettingsCollapsed ? '' : 'show'">
                    <button mat-menu-item
                            class="user-item-list settings-item"
                            *appCanAccess="centersSettingsAccess"
                            (click)="onCentersClick()">
                        <app-feather-icons [icon]="'map-pin'"
                                           [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                        <span class="user-item-label">{{ 'userProfileMenu.centers' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            class="user-item-list settings-item"
                            *appCanAccess="userAccess"
                            (click)="onUsersClick()">
                        <app-feather-icons [icon]="'users'"
                                           [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                        <span class="user-item-label">{{ 'userProfileMenu.users' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            class="user-item-list settings-item"
                            *appCanAccess="systemUpdatesAccess"
                            (click)="onSystemUpdatesClick()">
                        <app-feather-icons [icon]="'activity'"
                                           [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                        <span class="user-item-label">{{ 'userProfileMenu.systemUpdates' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            class="user-item-list settings-item"
                            *appCanAccess="rolesSettingsAccess"
                            (click)="onRolesClick()">
                        <app-feather-icons [icon]="'shield'"
                                           [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                        <span class="user-item-label">{{ 'userProfileMenu.roles' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            class="user-item-list settings-item"
                            *appCanAccess="createPermissAccess"
                            (click)="onCreatePermissAccessClick()">
                        <app-feather-icons [icon]="'key'"
                                           [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                        <span class="user-item-label">{{ 'userProfileMenu.permissions' | translate }}</span>
                    </button>
                    <button mat-menu-item
                            class="user-item-list settings-item"
                            *appCanAccess="modulosSettingsAccess"
                            (click)="onModulosClick()">
                        <app-feather-icons [icon]="'grid'"
                                           [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                        <span class="user-item-label">{{ 'userProfileMenu.modules' | translate }}</span>
                    </button>
                    
                    <button mat-menu-item
                            class="user-item-list settings-item"
                            *appCanAccess="notificationsSettingsAccess"
                            (click)="onNotificationsSettingsClick()">
                        <app-feather-icons [icon]="'bell'"
                                           [class]="'user-menu-icons settings-menu-icon'"></app-feather-icons>
                        <span class="user-item-label">{{ 'userProfileMenu.notifications' | translate }}</span>
                    </button>
                </div>

                <button mat-menu-item
                        class="user-item-list"
                        (click)="onLogoutClick()">
                    <app-feather-icons [icon]="'log-out'"
                                       [class]="'user-menu-icons'"></app-feather-icons>
                    <span class="user-item-label">{{ 'userProfileMenu.logout' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</mat-menu>
